module.exports = __webpack_public_path__ + "files/2fb645a113feeb834ba64eb8cd0c169c.png";